import React from 'react';
import { Alert, Typography } from 'antd';

const { Paragraph, Text } = Typography;

const LimitationLiabilitySection = () => {
  return (
    <div>
      <Paragraph>
        Customer acknowledges that TrackBiz is a software service provided to
        assist with business operations and that no software platform can
        eliminate all operational, financial, technical, or business risks.
      </Paragraph>

      <Paragraph>
        <Text strong>Limitation of Liability</Text>
      </Paragraph>

      <Paragraph>
        To the maximum extent permitted by law, Provider's total liability
        arising out of or relating to this Agreement, TrackBiz, or any services
        provided under this Agreement shall not exceed the total subscription
        fees paid by Customer during the twelve (12) months immediately
        preceding the event giving rise to the claim.
      </Paragraph>

      <Alert
        message="Maximum Liability Cap"
        description="Provider's maximum aggregate liability is limited to the subscription fees paid by Customer during the twelve (12) months preceding the claim."
        type="warning"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Under no circumstances shall Provider be liable for any indirect,
        incidental, consequential, special, exemplary, or punitive damages,
        regardless of the legal theory asserted.
      </Paragraph>

      <Paragraph>
        <Text strong>Excluded Damages Include:</Text>
      </Paragraph>

      <ul>
        <li>Lost profits</li>
        <li>Lost revenue</li>
        <li>Loss of business opportunities</li>
        <li>Loss of customers or goodwill</li>
        <li>Loss of anticipated savings</li>
        <li>Loss of data</li>
        <li>Business interruption</li>
        <li>Operational downtime</li>
      </ul>

      <Alert
        message="Third-Party Services"
        description="Provider is not responsible for losses, interruptions, outages, delays, or damages caused by third-party providers such as cloud hosting providers, payment processors, internet service providers, domain registrars, or other external services."
        type="info"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Customer acknowledges that TrackBiz relies upon third-party technology
        providers, including cloud infrastructure providers and payment
        processors, and that Provider is not responsible for failures or
        interruptions caused by such third parties.
      </Paragraph>

      <Paragraph>
        The limitations contained in this section apply regardless of whether
        Provider has been advised of the possibility of such damages and survive
        termination of this Agreement.
      </Paragraph>
    </div>
  );
};

export default LimitationLiabilitySection;